import { FunctionalComponent, h } from 'preact'
import classNames from 'classnames'
import { GroupedItemsList, ItemsList } from './interfaces'
import DropdownGroupedItemList from './item-lists/DropdownGroupedItemList'
import DropdownItemList from './item-lists/DropdownItemList'

export interface DropdownListProps {
  type?: string
  align: string
  items: ItemsList | GroupedItemsList
  displayListUpwards?: boolean
  hasSearch: boolean
  isOpen?: boolean
  searchPlaceholderText?: string
  searchIconWidth?: number
  searchIconHeight?: number
}

function isGrouped(items: ItemsList | GroupedItemsList): items is GroupedItemsList {
  return 'groupName' in items[0]
}

const DropdownList: FunctionalComponent<DropdownListProps> = ({
  type,
  align,
  items,
  displayListUpwards,
  hasSearch,
  isOpen = true,
  searchPlaceholderText,
  searchIconWidth,
  searchIconHeight
}) => {
  if (!isOpen) return null

  const classes = classNames(
    'control-dropdown__list',
    type ? `control-dropdown__list--${type}` : null,
    `control-dropdown__list--${align}`,
    displayListUpwards ? 'control-dropdown__list--up' : null
  )
  if (!items.length) return null

  if (isGrouped(items)) {
    return <DropdownGroupedItemList items={items} classes={classes} />
  }

  return (
    <DropdownItemList
      items={items}
      classes={classes}
      hasSearch={hasSearch}
      searchPlaceholderText={searchPlaceholderText}
      searchIconWidth={searchIconWidth}
      searchIconHeight={searchIconHeight}
    />
  )
}

export default DropdownList
